import { useState } from 'react';
import { Box, Toolbar } from '@mui/material';
import { Outlet, ScrollRestoration } from 'react-router';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

const drawerWidth = 240;

export const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100dvh' }}>
      <ScrollRestoration />
      <Header onMenuClick={handleDrawerToggle} />
      
      <Sidebar mobileOpen={mobileOpen} onDrawerToggle={handleDrawerToggle} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { xs: '100%', sm: `calc(100% - ${drawerWidth}px)` },
          bgcolor: 'background.default',
          minHeight: '100dvh',
          overscrollBehaviorY: 'none',
        }}
      >
        <Toolbar /> {/* Spacer for fixed AppBar */}
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
